/*Import Estilo*/
import './index.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';


/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';

/*Import Contexto*/
import { useAuth } from '../../../context/AuthContext';
import { useCart } from '../../../context/CartContext';

/*Import Requisição API*/
import api from '../../../api';
import { formatadorNumeroCelular, validadorNumeroCelular } from '../../../utils/Validadores/index.js';

export default function Contato() {


    const [nome, setNome] = useState('');
    const [sobrenome, setSobrenome] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [assunto, setAssunto] = useState('');
    const [mensagem, setMensagem] = useState('');

    const [loading, setLoading] = useState(false);

    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const recaptchaRef = useRef(null);

    const navigate = useNavigate();

    const { setUserId, setNivelAcesso } = useAuth();

    const [celularValido, setCelularValido] = useState(null);

    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const CaixaDeDialogoConfirmacao = useRef(null);
    const CaixaDeDialogoSucesso = useRef(null);
    useEffect(() => {
        CaixaDeDialogoConfirmacao.current = document.getElementById("CaixaDeDialogoConfirmacao");
    }, []);

    const abrirModalConfirmacao = (e) => {
        if (CaixaDeDialogoConfirmacao.current) {
            CaixaDeDialogoConfirmacao.current.showModal();
        }
    };

    const fecharModalConfirmacao = () => {
        if (CaixaDeDialogoConfirmacao.current) {
            CaixaDeDialogoConfirmacao.current.close();
            setRecaptchaToken(null);
        }
    };

    const CaixaDeDialogo = useRef(null);
    useEffect(() => {
        CaixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const abrirModal = (e) => {
        if (CaixaDeDialogo.current) {
            CaixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        if (CaixaDeDialogo.current) {
            CaixaDeDialogo.current.close();
            setRecaptchaToken(null);
        }
    };

    const onRecaptchaChange = (token) => {
        console.log('recaptcha token recebido (change):', token);
        setRecaptchaToken(token);
    };

    useEffect(() => {
        CaixaDeDialogoSucesso.current = document.getElementById("CaixaDeDialogoSucesso");
    }, []);

    const mostrarModalSucesso = () => {
        if (CaixaDeDialogoSucesso.current) {
            CaixaDeDialogoSucesso.current.showModal();
        }
    };

    const handleCelularChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        setTelefone(value);

        if (value.length === 0) {
            setCelularValido(null);
        } else {
            setCelularValido(validadorNumeroCelular(value));
        }
    };

    const handleBlur = () => {
        const formattedValue = formatadorNumeroCelular(telefone);
        setTelefone(formattedValue);
    };

    const handleSubmit = async (e) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        setLoading(true);
        fecharModalConfirmacao();

        const formDataToSend = {
            firstName: nome,
            lastName: sobrenome,
            email,
            subject: assunto,
            phone: telefone,
            message: mensagem,
            recaptchaToken // incluímos o token para validação no backend
        };

        try {
            console.log('Enviando para /caseSalesforce', formDataToSend);
            const response = await api.post('/caseSalesforce', formDataToSend);

            // limpa campos
            setNome(''); setSobrenome(''); setEmail(''); setTelefone(''); setAssunto(''); setMensagem('');

            // Fecha modal de confirmação
            fecharModalConfirmacao();

            console.log('Resposta backend:', response.data);

            if (response.data.success) {
                setTexto('Obrigado por falar conosco! Em breve entraremos em contato!');
                mostrarModalSucesso();
                setTimeout(() => { navigate('/'); }, 5000);
            } else {
                alert(response.data.message || 'Erro ao enviar o caso.');
            }
        } catch (error) {
            console.error('Erro ao enviar o caso:', error);
            if (error.response) {
                console.error('error.response.data:', error.response.data);
                alert(`Erro do servidor: ${error.response.status} - ${JSON.stringify(error.response.data)}`);
            } else if (error.request) {
                console.error('No response (request):', error.request);
                alert('Sem resposta do servidor. Verifique a conexão.');
            } else {
                console.error('Error message:', error.message);
                alert('Erro: ' + error.message);
            }
        } finally {
            setLoading(false);
            try { recaptchaRef.current?.reset(); } catch (e) { }
            setRecaptchaToken(null);
        }
    };

    const handleConfirmarEnviar = async (e) => {
        e.preventDefault();
        if (!nome || !sobrenome || !email || !assunto || !telefone || !mensagem) {
            setTexto('Preencha todos os campos para enviar o formulario!');
            abrirModal();
            return;
        }
        if (!recaptchaToken) {
            abrirModalConfirmacao();
            return;
        }
        await handleSubmit();
    };

    return (
        <section className='container-Principal-Contato'>

            <Cabecalho />

            <CookieAceite />
            <dialog id="CaixaDeDialogoConfirmacao" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <h3>Confirme que você não é um robô</h3>
                    <p>Marque a caixa abaixo e depois clique em "Confirmar e Enviar".</p>

                    <div style={{ margin: '16px 0' }}>
                        <ReCAPTCHA
                            sitekey={'6LfQ7_crAAAAAMdMzALHq9aIV07Zgr41Wif-eswp'}
                            onChange={onRecaptchaChange}
                            ref={recaptchaRef}
                            theme="light"
                        />
                    </div>

                    <div className='dialog-button'>
                        <button className='cancelar' onClick={fecharModalConfirmacao} disabled={loading}>Cancelar</button>
                        <button
                            onClick={handleConfirmarEnviar}
                            disabled={!recaptchaToken || loading}
                            className='confirmar'
                        >
                            {loading ? 'Enviando...' : 'Confirmar e Enviar'}
                        </button>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaDeDialogoSucesso">
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><g fill="none" stroke="#4AC204" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path stroke-dasharray="64" stroke-dashoffset="64" d="M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0" /></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M8 12l3 3l5 -5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.6s" dur="0.2s" values="14;0" /></path></g></svg>
                        <p>{texto}</p>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModal}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <main className="main-Problema">
                <section className="conteudoMain">
                    <ul class="circulos">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    {loading ? (
                        <div className="loading">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="#fff" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                            <h2>Carregando...</h2>
                        </div>
                    ) : (
                        <>
                            <div className='container-interno-forms'>
                                <h2>Entre em contato conosco</h2>
                                <h3>Tem alguma dúvida ou problema? Conte-nos e ajudaremos você!</h3>
                                <form className='container-forms'>
                                    <div className='dadosDuplos'>
                                        <div className='dado'>
                                            <label className='label-Nome' htmlFor="Nome">Nome:<span>*</span></label>
                                            <div className='container-Nome'>
                                                <input
                                                    type='text'
                                                    name='nome'
                                                    maxLength={128}
                                                    placeholder='Digite seu nome'
                                                    value={nome}
                                                    onChange={(e) => setNome(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className='dado'>
                                            <label className='label-Sobrenome' htmlFor="Sobrenome">Sobrenome:<span>*</span></label>
                                            <div className='container-Sobrenome'>
                                                <input
                                                    type='text'
                                                    name='sobrenome'
                                                    maxLength={128}
                                                    placeholder='Digite seu sobrenome'
                                                    value={sobrenome}
                                                    onChange={(e) => setSobrenome(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='dadosDuplos'>
                                        <div className='dado'>
                                            <label className='label-Email' htmlFor="Email">E-mail:<span>*</span></label>
                                            <div className='container-Email'>
                                                <input
                                                    type='email'
                                                    name='email'
                                                    placeholder='Digite seu email'
                                                    maxLength={128}
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className='dado'>
                                            <label className='label-Telefone' htmlFor="Telefone">Telefone:<span>*</span></label>
                                            <div className='container-Telefone'>
                                                <input
                                                    type='phone'
                                                    value={telefone}
                                                    onChange={handleCelularChange}
                                                    onBlur={handleBlur}
                                                    placeholder='Digite um número de celular'
                                                    maxLength={15}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <label className='label-Assunto' htmlFor="Assunto">Assunto:<span>*</span></label>
                                    <div className='container-Assunto'>
                                        <input
                                            type='text'
                                            name='assunto'
                                            placeholder='Digite o assunto'
                                            maxLength={128}
                                            value={assunto}
                                            onChange={(e) => setAssunto(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <label className='label-Mensagem' htmlFor="Mensagem">Mensagem:<span>*</span></label>
                                    <div className='container-Mensagem'>
                                        <textarea
                                            name="mensagem"
                                            placeholder="Digite sua mensagem"
                                            value={mensagem}
                                            onChange={(e) => {
                                                setMensagem(e.target.value)
                                                e.target.style.height = 'auto';
                                                e.target.style.height = `${e.target.scrollHeight}px`;
                                            }}
                                            maxLength={2000}
                                            style={{ overflow: 'hidden', resize: 'none' }}
                                        />
                                    </div>
                                    <button className='enviar-contato' onClick={handleConfirmarEnviar} disabled={loading}>
                                        {loading ? 'Enviando...' : 'Enviar'}
                                    </button>
                                </form>
                            </div>
                        </>
                    )}
                </section>
            </main>

            <Rodape />

        </section >
    );
}